/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PostJobAttachmentPayload } from 'api/actions/post-job-attachment/post-job-attachment-payload';
import { PostJobAttachmentPathParameters } from 'api/actions/post-job-attachment/post-job-attachment-path-parameters';
import { PostJobAttachmentResponse } from 'api/actions/post-job-attachment/post-job-attachment-response';

type PostJobAttachmentQueryParameters = Record<string, any>;

/**
 * The path of the PostJobAttachment action.
 */
export const postJobAttachmentActionPath = new SweetPath<keyof PostJobAttachmentPathParameters>(
  '/help-desk/jobs/{jobId}/attachments',
  { path: '{param}' }
);

/**
 * Creates a contextualized PostJobAttachment actions.
 */
export default function createPostJobAttachmentAction(axios: AxiosInstance) {
  return function postJobAttachmentAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: PostJobAttachmentPathParameters;
    query?: PostJobAttachmentQueryParameters;
    payload: PostJobAttachmentPayload;
  }) {
    const path = postJobAttachmentActionPath.insert(parameters);

    return axios.post<PostJobAttachmentResponse, PostJobAttachmentResponse, PostJobAttachmentPayload>(path, payload);
  };
}
